import Vue from 'vue'
import Draggable from 'vuedraggable'

Vue.component('Draggable', Draggable)

window.sortFunction = function(a, b) {
  if (a.text > b.text) {
    return 1
  }
  if (a.text < b.text) {
    return -1
  }
  return 0
}
